import ServiceVariation from '../../services/Variations';
import { HTTP_STATUS_CODE } from '../../helpers/constants';

export const LOADING_VARIATION = 'LOADING_VARIATION';
export function loadingVariation() {
  return {
    type: LOADING_VARIATION,
  };
}

export const RECEIVE_VARIATIONS = 'RECEIVE_VARIATIONS';
export function receiveVariations(variations) {
  return {
    type: RECEIVE_VARIATIONS,
    payload: variations,
  };
}

export const VARIATION_ERROR = 'VARIATION_ERROR';
export function variationError(error) {
  return {
    type: VARIATION_ERROR,
    error,
  };
}

export const LOADING_CREATE_VARIATION = 'LOADING_CREATE_VARIATION';
export function loadingCreate() {
  return {
    type: LOADING_CREATE_VARIATION,
  };
}

export const LOADING_EDIT_VARIATION = 'LOADING_EDIT_VARIATION';
export function loadingEdit() {
  return {
    type: LOADING_EDIT_VARIATION,
  };
}

export const LOADING_DELETE_VARIATION = 'LOADING_DELETE_VARIATION';
export function loadingDelete() {
  return {
    type: LOADING_DELETE_VARIATION,
  };
}

export const DELETE_VARIATION_SUCCESS = 'DELETE_VARIATION_SUCCESS';
export function deleteVariationSuccess(id) {
  return {
    type: DELETE_VARIATION_SUCCESS,
    id,
  };
}

export const DELETE_VARIATION_FAILURE = 'DELETE_VARIATION_FAILURE';
export function deleteVariationFailure(error) {
  return {
    type: DELETE_VARIATION_FAILURE,
    error,
  };
}

export const FINISH_SUBMIT_VARIATION = 'FINISH_SUBMIT_VARIATION';
export function finishSubmitVariation() {
  return {
    type: FINISH_SUBMIT_VARIATION,
  };
}

export const FINISH_DELETE_VARIATION = 'FINISH_DELETE_VARIATION';
export function finishDeleteVariation() {
  return {
    type: FINISH_DELETE_VARIATION,
  };
}

export const CREATE_VARIATION_SUCCESS = 'CREATE_VARIATION_SUCCESS';
export function createVariationSuccess(variation) {
  return {
    type: CREATE_VARIATION_SUCCESS,
    payload: variation,
  };
}

export const CREATE_VARIATION_FAILURE = 'CREATE_VARIATION_FAILURE';
export function createVariationFailure(error) {
  return {
    type: CREATE_VARIATION_FAILURE,
    error,
  };
}

export const EDIT_VARIATION_SUCCESS = 'EDIT_VARIATION_SUCCESS';
export function editVariationSuccess(variation) {
  return {
    type: EDIT_VARIATION_SUCCESS,
    payload: variation,
  };
}

export const EDIT_VARIATION_FAILURE = 'EDIT_VARIATION_FAILURE';
export function editVariationFailure(error) {
  return {
    type: EDIT_VARIATION_FAILURE,
    error,
  };
}

export const getVariations = () => {
  return async dispatch => {
    try {
      dispatch(loadingVariation());
      const response = await new ServiceVariation().getAll();
      if (response) {
        dispatch(receiveVariations(response.data || []));
      } else {
        dispatch(
          variationError({
            error: true,
          })
        );
      }
    } catch (err) {
      console.error('error', err);
      dispatch(
        variationError({
          error: true,
        })
      );
    }
  };
};

export function createVariation(variation) {
  return async dispatch => {
    dispatch(closeModal());
    dispatch(loadingCreate());
    try {
      const response = await new ServiceVariation().post(variation);
      if (response.status !== HTTP_STATUS_CODE.CREATED) {
        throw new Error('Erro na criação da variação');
      }
      dispatch(createVariationSuccess(response.data));
    } catch (err) {
      dispatch(
        createVariationFailure({
          error: true,
          message:
            err.response && err.response.data.message && err.response.data.message.name
              ? err.response.data.message.name
              : 'Erro! Verifique os dados e tente novamente',
        })
      );
      console.error('error', err);
    }
  };
}

export function editVariation(variation) {
  return async dispatch => {
    dispatch(closeModal());
    dispatch(loadingEdit());
    try {
      const response = await new ServiceVariation().put(variation);
      if (response.status !== HTTP_STATUS_CODE.OK) {
        throw new Error('Erro ao atualizar a variação');
      }
      dispatch(editVariationSuccess(response.data));
    } catch (err) {
      dispatch(
        editVariationFailure({
          error: true,
          message:
            err.response && err.response.data.message && err.response.data.message.name
              ? err.response.data.message.name
              : 'Erro! Verifique os dados e tente novamente',
        })
      );
      console.error('error', err);
    }
  };
}

export function deleteVariation(id) {
  return async dispatch => {
    try {
      dispatch(loadingDelete());
      const response = await new ServiceVariation().delete(id);
      if (!response) {
        throw new Error('Erro ao deletar variação');
      }
      dispatch(deleteVariationSuccess(id));
    } catch (error) {
      dispatch(
        deleteVariationFailure({
          message: 'Erro ao deletar variação',
        })
      );
      console.error('error', error);
    }
  };
}

export const SHOW_VARIATION_MODAL = 'SHOW_VARIATION_MODAL';
export function showModal(type, variation) {
  let payload = {};
  switch (type) {
    case 'edit':
      payload = {
        showEditVariantModal: true,
        variation,
      };
      break;
    case 'delete':
      payload = {
        showDeleteVariantModal: true,
        variation,
      };
      break;
    default:
      payload = {
        showCreateVariantModal: true,
      };
      break;
  }
  return {
    type: SHOW_VARIATION_MODAL,
    payload,
  };
}

export const CLOSE_VARIATION_MODAL = 'CLOSE_VARIATION_MODAL';
export function closeModal() {
  return {
    type: CLOSE_VARIATION_MODAL,
  };
}



// WEBPACK FOOTER //
// ./src/store/variations/actions.js